import * as theme from '@zero/design-tokens/build/js/variables';
import styled from 'styled-components';

interface BoxVcpuProps {
    margin: number;
}

export const TitlePriceBox = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding: 0px 0px;
    margin-bottom: 20px;
`;

export const SliderBox = styled.div`
    padding: 0px 15px;
`;

export const BoxVcpu = styled.div<BoxVcpuProps>`
    margin-top: ${(props) => props.margin}px;
`;

export const TitleConfig = styled.span`
    font-family: ${theme.ZrFontFamilyDigitalLight};
    font-size: ${theme.ZrFontSizeXxxs};
    font-weight: bold;
`;

